module.exports = __webpack_public_path__ + "img/register_te.4ad2a6f2.png";